import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=4454f16f&scoped=true"
import script from "./ServiceSummary.vue?vue&type=script&lang=js"
export * from "./ServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=4454f16f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454f16f",
  null
  
)

export default component.exports